import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostMonitorSubscribeRequest = {
    id: number,
	subscribe: boolean
};

export const subscribeDataSecurityMonitorById = createPostEndpoint<PostMonitorSubscribeRequest>(
	(request) => `/api/v3/data-security/monitors/${request.id}/subscribe`,
	{
		requestTransform: ({ subscribe }) => ({ Subscribe: subscribe })
	}
);
